import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { BookingEngineStoreEffects } from './effects';
import { bookingEngineReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('bookingEngine', bookingEngineReducer),
    EffectsModule.forFeature([BookingEngineStoreEffects]),
  ],
})
export class BookingEngineStoreModule {}
